import { render, staticRenderFns } from "./parts-order-view.vue?vue&type=template&id=517f3a4f&scoped=true"
import script from "./parts-order-view.vue?vue&type=script&lang=js"
export * from "./parts-order-view.vue?vue&type=script&lang=js"
import style0 from "./parts-order-view.vue?vue&type=style&index=0&id=517f3a4f&prod&lang=scss&scoped=true"
import style1 from "./parts-order-view.vue?vue&type=style&index=1&id=517f3a4f&prod&scoped=true&lang=css"
import style2 from "./parts-order-view.vue?vue&type=style&index=2&id=517f3a4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517f3a4f",
  null
  
)

export default component.exports